"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 4.435c5.057 0 9.172 4.114 9.172 9.172 0 5.057-4.115 9.172-9.172 9.172s-9.172-4.115-9.172-9.172c0-5.058 4.115-9.172 9.172-9.172Zm0 1.027c-4.49 0-8.145 3.654-8.145 8.145 0 4.49 3.654 8.144 8.145 8.144 4.492 0 8.145-3.653 8.145-8.144S16.492 5.462 12 5.462Zm0 2.122c.269 0 .466.166.506.416l.008.097v5.296l4.521 3.742a.64.64 0 0 1 .209.438.4.4 0 0 1-.122.29c-.091.091-.278.192-.4.192-.07 0-.16 0-.251-.058l-4.784-3.983a.573.573 0 0 1-.192-.311l-.008-.096v-5.51A.49.49 0 0 1 12 7.584ZM5.782.5c.804 0 1.492.468 1.842 1.252a1.914 1.914 0 0 1-.307 2.058l-.113.121L3.9 7.238a1.974 1.974 0 0 1-1.423.586c-.257 0-.507-.083-.747-.164C.936 7.308.467 6.62.467 5.815c0-.487.16-.93.465-1.292l.122-.132L4.36 1.086A1.97 1.97 0 0 1 5.782.5Zm12.435 0c.489 0 .93.16 1.293.465l.132.12 3.305 3.307c.373.371.586.89.586 1.423 0 .804-.468 1.492-1.251 1.84-.252.085-.501.169-.758.169a1.97 1.97 0 0 1-1.291-.466l-.132-.12-3.306-3.307c-.592-.591-.752-1.427-.418-2.18C16.726.969 17.413.5 18.217.5Zm0 1.026c-.393 0-.68.174-.855.514l-.055.12a.868.868 0 0 0 .12.951l.089.1 3.306 3.306c.36.361.774.348 1.042.213.293-.146.642-.424.642-.915 0-.261-.058-.443-.201-.617l-.079-.086-3.305-3.306c-.2-.201-.398-.28-.704-.28Zm-12.435 0c-.26 0-.443.058-.616.201l-.086.079-3.306 3.306c-.202.202-.28.399-.28.703 0 .393.172.68.513.856l.12.055a.87.87 0 0 0 .952-.12l.1-.09 3.305-3.305c.328-.328.347-.7.248-.966l-.034-.076c-.172-.43-.479-.642-.916-.642Z",
    clipRule: "evenodd"
  })]
});